import { parsePropertyId } from '../../../helpers/property-portfolio';

export const generatePropBasedOnIdentifier = identifier => ({
  propertyId: parsePropertyId(identifier)
});
